import React from 'react'

function Footer() {
  return (
  <footer>

    <div className="footer-end">
      <p>(c) 2024 Kanmani Moto Bikes. All rights reserved. Develoeped By Avatar Global Services</p>
    </div>
  </footer>
  )
}

export default Footer